import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import Sidebar from "./components/Sidebar";
import MobileNavbar from "./components/MobileNavbar";
import ProtectedRoute from "./routes/ProtectedRoute";
import { protectedRoutes, publicRoutes } from "./routes/routes";
import NotFoundPage from "./pages/NotFoundPage";
import { useAuth } from "./context/AuthContext";
import MobileHeader from "./components/MobileHeader";
import ComingSoon from "./pages/ComingSoon";
import { membershipAxios } from "./services/membership/MembershipAxios";
import Loader from "./components/common/Loader";
import ButtonWs from "./components/ButtonWs";

const AppContent = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  // const [isLoading, setIsLoading] = useState(false);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  const verifyMembership = async () => {
    if (protectedRoutes.some(route => location.pathname === route.path) === false) {
      return;
    }

    if (location.pathname === "/settings") {
      return;
    }

    try {
      // setIsLoading(true);
      const membership = await membershipAxios();
      if (location.pathname === "/plans" && membership.credits > 0) {
        navigate("/home");
      }
      if (location.pathname === "/onboarding" && membership.credits < 1) {
        navigate("/plans");
      }
      // setIsLoading(false);
    } catch (error: any) {
      console.error("Error fetching membership:", error);
      if (error.response?.data.trigger === "NOT_ACTIVE_MEMBERSHIP") {
        navigate("/plans");
      }
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isLoading) return;
    verifyMembership();
  }, [location.pathname, isLoading]);

  useEffect(() => {
    if (isLoading) return;
    if (
      isAuthenticated &&
      (location.pathname === "/login" || location.pathname === "/signup")
    ) {
      navigate("/home");
    }
  }, [isAuthenticated, location.pathname, navigate, isLoading]);

  const routes = ["/", "/login", "/signup", "/login/offer"]

  return (
    // <SubscriptionProvider>
    <div
      className={`hard-flex min-h-screen bg-[#F5F6FA] font-['Plus_Jakarta_Sans'] ${location.pathname === "/" ? "p-0" : ""
        }`}
    >
      <div className="md:hidden pb-6 mb-6">
        {isAuthenticated && !routes.includes(location.pathname) ? (
          <MobileHeader />
        ) : (
          <></>
        )}
      </div>
      {/* Sidebar for Desktop */}
      {isAuthenticated && !routes.includes(location.pathname) && (
        <div className="hidden md:block">
          <Sidebar />
        </div>
      )}

      {/* Main Content */}
      <div
        className={`flex-1 ${isAuthenticated && !routes.includes(location.pathname) && location.pathname !== "/"
          ? location.pathname === "/website/builder"
            ? isHovered
              ? "md:ml-60 ml-0"
              : "md:ml-16 ml-0"
            : "md:ml-60 ml-0"
          : "ml-0"
          }`}
      >
        <Routes>
          {/* Public Routes */}
          {publicRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
          {isLoading ? (
            <Route path="*" element={
              <div className="flex justify-center items-center h-screen">
                <Loader />
              </div>
            } />
          ) : (
            protectedRoutes.map(({ path, element }) => (
              <Route
                key={path}
                path={path}
                element={<ProtectedRoute>{element}</ProtectedRoute>}
              />
            ))
          )}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>

      {/* Mobile Navbar */}
      <div className="md:hidden">
        {isAuthenticated && !routes.includes(location.pathname) ? (
          <MobileNavbar />
        ) : (
          <></>
        )}
      </div>
    </div>
    // </SubscriptionProvider>
  );
};

const App = () => {
  const routes = ["/", "/login/offer"]

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 2000,
        }}
      />
      {!routes.includes(location.pathname) ? (
        <>
          <div className="hidden md:block">
            <AppContent />
            <ButtonWs />
          </div>
          <div className="md:hidden">
            <ComingSoon />
          </div>
        </>
      ) : (
        <AppContent />
      )}
    </Router>
  );
};

export default App;
